// Accent-color preference. Sets `data-accent` on <html> so the CSS token layer
// (tokens.css) overrides --accent/--accent-soft/--accent-deep. Built on the
// shared createPreference primitive; the named exports below are the stable
// public surface (consumed by useAccent, src/index.jsx and the lib barrel).
import { createPreference } from './preference';

const pref = createPreference('rec:accent', {
  fallback: 'blue',
  valid: ['blue', 'green', 'neutral'],
  applyAttr: 'accent',
});

export const accentPref = pref;
export const initAccent = pref.init;
export const setAccent = pref.set;
